<template>
    <div v-if="timeRemaining">
        <span>{{ timeRemaining.days}}<span>روز</span></span>
        <span>{{ timeRemaining.hours}}<span>ساعت</span></span>
        <span>{{ timeRemaining.minutes}}<span>دقیقه</span></span>
        <span>{{ timeRemaining.seconds}}<span>ثانیه</span></span>
    </div>
</template>

<script>
export default {
    name: 'Countdown',
    props: {
        endDate: {
            type: String,
            required: true
        },
        serverDate: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            timeRemaining: null,
            interval: null
        };
    },
    computed: {
        endTime() {
            return new Date(this.endDate).getTime();
        },
        serverTime() {
            return new Date(this.serverDate).getTime();
        }
    },
    methods: {
        calculateTimeRemaining() {
            const now = new Date().getTime();
            const distance = this.endTime - now;

            if (distance < 0) {
                clearInterval(this.interval);
                this.timeRemaining = null;
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            this.timeRemaining = { days, hours, minutes, seconds };
        }
    },
    mounted() {
        this.calculateTimeRemaining();
        this.interval = setInterval(this.calculateTimeRemaining, 1000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
};
</script>

<style scoped>
/* Add your styles here */
</style>
